import * as React from 'react';

function SvgTick({ color = 'black', width = '13', height = '13', isTabTick }) {
  if (isTabTick) {
    return (
      <svg
        id="iconTick"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.1244 4.96176C12.2721 4.81656 12.5095 4.81858 12.6547 4.96626C12.7999 5.11395 12.7979 5.35138 12.6502 5.49657L6.50499 11.5382C6.35912 11.6817 6.12521 11.6817 5.97929 11.5383L3.3495 8.95477C3.20176 8.80963 3.19966 8.5722 3.3448 8.42446C3.48994 8.27672 3.72737 8.27462 3.87511 8.41976L6.24199 10.745L12.1244 4.96176Z"
          fill="black"
        />
      </svg>
    );
  }
  return (
    <svg
      id="iconTick"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0742 3.86668C10.2022 3.74085 10.408 3.74259 10.5338 3.87059C10.6597 3.99858 10.6579 4.20435 10.5299 4.33019L5.20407 9.5663C5.07764 9.6906 4.87493 9.69063 4.74845 9.56639L2.46931 7.3273C2.34127 7.20151 2.33944 6.99574 2.46523 6.8677C2.59102 6.73966 2.79679 6.73783 2.92483 6.86362L4.97613 8.87887L10.0742 3.86668Z"
        fill={color}
      />
    </svg>
  );
}

export default SvgTick;
